import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  root: {
    borderRadius: "10px",
    backgroundColor: theme.colors.white,
    width: "500px",
    maxWidth: '90vw',
    overflow: "auto",
    padding: "20px",
    margin: "20px",
    maxHeight: 'calc(100vh - 40px)',
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& p': {
      fontWeight: "bold",
      marginBottom: "0",
    },
  },
  body: {
    marginTop: "20px",
    maxHeight: 'calc(100vh - 300px)',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: '16px',
    gap: '10px',
  },
  repeatFrequencyWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& > span': {
      whiteSpace: 'nowrap',
      paddingRight: '12px',
    },
  },
  frequencyInputWrapper: {
    display: 'flex',
    gap: '4px',
  },
  frequencyInput: {
    width: '50px !important',
    '& > div': {
      width: 'inherit',
      minHeight: '42px',
    },
  },
  autoSelect: {
    width: 'fit-content !important',
    minWidth: '100px',
    flex: 'unset !important',
  },
  repeatDaysWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
  },
  dayButton: {
    width: '32px',
    height: '32px',
    fontSize: '14px',
    backgroundColor: theme.colors.grey[300],
    color: theme.colors.black,
    '&.active': {
      backgroundColor: theme.colors.primaryBlue[100],
      color: theme.colors.primaryBlue[500],
    },
  },
  repeatMonthWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '16px',
    '& > span': {
      whiteSpace: 'nowrap',
      visibility: 'hidden',
    },
  },
  monthInput: {
    width: '200px !important',
    '& > div': {
      width: '200px',
      minHeight: '42px',
    },
  },
  repeatEndWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    '& > span': {
      whiteSpace: 'nowrap',
    },
  },
  endInputWrapper: {
    display: 'flex',
    gap: '4px',
  },
  endInput: {
    width: '160px !important',
    '& > div': {
      width: 'inherit',
      minHeight: '42px',
      '& > span': {
        backgroundColor: 'transparent',
        borderRadius: '0',
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'inherit',
        flex: '1 0 60%',
      },
    },
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  datePicker: {
    width: '100px',
  },
}));

export default useStyles;